import { createContext, useContext, FC, ReactNode } from "react";
import { TSharedEnumOptions, TSharedMasterData } from "@/api/services/main/sharing/dtos/sharing.dto";

const SharedEnumContext = createContext<TSharedEnumOptions | null>(null);
const SharedMasterDataContext = createContext<TSharedMasterData | null>(null);

export const useSharedEnumOptions = () => useContext(SharedEnumContext);
export const useSharedMasterData = () => useContext(SharedMasterDataContext);

type TSharedEnumProviderProps = {
  enumOptions?: TSharedEnumOptions;
  masterData?: TSharedMasterData;
  children: ReactNode;
};

export const SharedEnumProvider: FC<TSharedEnumProviderProps> = ({ enumOptions, masterData, children }) => (
  <SharedEnumContext.Provider value={enumOptions ?? null}>
    <SharedMasterDataContext.Provider value={masterData ?? null}>{children}</SharedMasterDataContext.Provider>
  </SharedEnumContext.Provider>
);
